import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { fetchWithAuth } from '@/lib/fetchWithAuth'
import { initConsoleFilter } from '@/utils/consoleFilter'

// Inicializar filtro de console ANTES de qualquer outro código
// Isso filtra logs de extensões do navegador (ex: Phantom Wallet)
initConsoleFilter()

// Monkey-patch global fetch to inject Authorization header when applicable
const originalFetch = window.fetch.bind(window)
// Store reference globally for exceptions (like Aldo API)
;(window as any).__originalFetch = originalFetch
window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
  // Use our wrapper for same-origin and backend API calls
  return fetchWithAuth(input, init)
}

createRoot(document.getElementById("root")!).render(<App />);
